import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import NotificationContainer from './components/NotificationContainer';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Products from './pages/Products';
import MyKeys from './pages/MyKeys';
import Purchase from './pages/Purchase';
import Admin from './pages/Admin';
import Exchange from './pages/Exchange';
import Security from './pages/Security';

function App() {
  return (
    <AuthProvider>
      <NotificationProvider>
        <Router>
          <div className="App">
            <NotificationContainer />
            <Routes>
              {/* Public routes */}
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              
              {/* Protected routes */}
              <Route path="/dashboard" element={
                <ProtectedRoute>
                  <Layout>
                    <Dashboard />
                  </Layout>
                </ProtectedRoute>
              } />
              
              <Route path="/products" element={
                <ProtectedRoute>
                  <Layout>
                    <Products />
                  </Layout>
                </ProtectedRoute>
              } />
              
              <Route path="/my-keys" element={
                <ProtectedRoute>
                  <Layout>
                    <MyKeys />
                  </Layout>
                </ProtectedRoute>
              } />
              
              <Route path="/purchase" element={
                <ProtectedRoute>
                  <Layout>
                    <Purchase />
                  </Layout>
                </ProtectedRoute>
              } />
              
              <Route path="/admin" element={
                <ProtectedRoute allowedRoles={['reseller', 'owner']}>
                  <Layout>
                    <Admin />
                  </Layout>
                </ProtectedRoute>
              } />

              <Route path="/exchange" element={
                <ProtectedRoute>
                  <Layout>
                    <Exchange />
                  </Layout>
                </ProtectedRoute>
              } />

              <Route path="/settings/security" element={
                <ProtectedRoute>
                  <Layout>
                    <Security />
                  </Layout>
                </ProtectedRoute>
              } />
              
              {/* Default redirect */}
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </div>
        </Router>
      </NotificationProvider>
    </AuthProvider>
  );
}

export default App;
